<template>
  <popper
    :trigger="triggerType"
    :options="{
      placement: positionType,
      modifiers: { offset: { offset: '0,5px' } },
    }"
  >
    <div class="popper" v-if="header || title || message || helpLink">
      <div v-if="header" class="popper-header">
        <div class="popper-header-title">
          {{ header }}
        </div>
      </div>
      <div class="popper-body">
        <h6 v-if="title">
          {{ title }}
        </h6>
        <slot name="message">
          <p v-if="message" v-html="message"></p>
        </slot>
        <template v-for="(help, h) in helpLink">
          <p :key="h" class="text-right">
            <Btn variant="link" href="" @click="helpAction(help)">
              <span v-if="!help.icon">{{ help.name || $t("global.learn-more") }}</span>
              <span v-if="help.icon">
                <Icon
                  :alt="help.name"
                  class="help-icon ml-1"
                  :icon="help.icon || 'help'"
                  :color="help.iconColor || 'default'"
                />
              </span>
            </Btn>
          </p>
        </template>
      </div>
    </div>
    <slot slot="reference"></slot>
  </popper>
</template>

<script>
import Btn from "@/components/display/Btn";
import { computed } from "@vue/composition-api";
import Icon from "@/components/display/icon/Icon";
import Popper from "@/components/display/Popper";

export default {
  name: "Popover",
  components: { Btn, Icon, Popper },
  props: {
    header: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    helpLink: Array,
    trigger: {
      type: String,
      default: "hover",
    },
    position: {
      type: String,
      default: "right",
    },
  },
  setup(props) {
    const positionList = {
      left: "left",
      right: "right",
      top: "top",
      bottom: "bottom",
    };
    const positionType = computed(() => {
      return positionList[props.position];
    });
    const triggerList = {
      hover: "hover",
      click: "clickToOpen",
      toggle: "clickToToggle",
    };
    const triggerType = computed(() => {
      return triggerList[props.trigger];
    });

    const helpAction = (help) => {
      if (help.action) {
        help.action();
      }
    };

    return {
      helpAction,
      positionType,
      triggerType,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.popper {
  text-align: left;
  max-width: 400px;

  .popper-header {
    height: 2rem;
    padding: 0 0.75rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom-style: solid;
    border-bottom-width: 1px;

    .popper-header-title {
      font-size: 1rem;
      font-weight: bold;
      line-height: 1rem;
    }
  }

  .popper-body {
    padding: 1rem 0.75rem 0 0.75rem;
  }
}
</style>
